<template>
  <div id="smartTown">
    <div class="title">海南省加快推进数字疗法产业发展的若干措施</div>
    <div class="text">为贯彻落实习近平总书记在庆祝海南建省办经济特区30周年大会上关于“海南要深化供给侧结构性改革，发挥优势，集聚创新要素，积极发展新一代信息技术产业和数字经济”的讲话精神，抢抓历史机遇，通过2—3年的努力将海南建设成为全球数字疗法创新岛、创新资源集聚区和产业高地，将数字疗法打造成海南健康产业高质量发展的“新引擎”，推动海南电子政务跨越式发展和“十四五”期间人均预期寿命提高两岁目标的实现，特制定以下措施：</div>
    <div class="btn" @click="toLink()">查看详情</div>
   
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
  methods:{
    toLink(){
      window.open('https://www.hainan.gov.cn/hainan/zchbhnwj/202210/a231c28b9448421e87badce2681b3924.shtml')
    }
  }
};
</script>
<style scoped>
.btn{
  margin: 40px auto 20px;
  display: block;
  border-radius: 4px;
  width: 80px;
  color: #1e73be;
  border: 1px solid #1e73be;
}
.btn:hover{
  color: #1e73be ;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 15px;
  margin-right: 20px;
  text-indent: 28px
}
.sub-title{
  color: #666;
  font-size: 18px;
  text-align: center;
}
.right{
  text-align: right;
  color: #666;
  font-size: 20px;
}
.title{
  font-weight: bold;
  font-size: 24px;
  margin-top: 10px;
  text-align: center;
}
.title1{
  font-weight: bold;
  font-size: 26px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/view/news10.vue